require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /var/www/build-health-2/~/core-js/modules/es7.symbol.observable.js
// module id = 1330
// module chunks = 0